import { SearchQuery } from "../code/search-query/search-query";
import ManagedGridView from "../controls/ManagedGridView";
import {
  loginLogsViewColumns,
  mapLoginLogsViewQuery,
} from "./LoginLogsView.default";
import { getLoginLogs } from "../repository/data.repository";
import { createGridRequest } from "../hooks/useGridRequest";

export interface LoginLogsViewProps {
  readonly trigger?: string;
  readonly onSearch?: (searchQuery: SearchQuery) => void;
}

function LoginLogsView(props: LoginLogsViewProps) {
  return (
    <ManagedGridView
      trigger={props.trigger}
      columns={loginLogsViewColumns}
      mapQuery={mapLoginLogsViewQuery}
      onSearch={props.onSearch}
      request={createGridRequest(getLoginLogs, { retry: true })}
      pageSize={100}
      schema={{
        groups: [
          {
            controls: [
              { type: "textbox", name: "userUserName", label: "User" },
              { type: "textbox", name: "companyName", label: "Company" },
              { type: "textbox", name: "ipAddress", label: "IP Address" },
              { type: "textbox", name: "loginProvider", label: "Login Provider" },
            ],
          },
        ],
      }}
      actions={() => []}
    />
  );
}

export default LoginLogsView;
